import { useTranslation } from "react-i18next";
import React from "react";
import { A } from "../styles/appleClasses"; // adjust path if needed

export default function StepProgress({ step, importStage = false }: { step: number; importStage?: boolean }) {
  const steps = [
    "directory.common.name",
    "onboarding.progress.accounts",
    "sales.common.payment",
    "onboarding.titles.privacy",
    "onboarding.progress.yearEnd",
    importStage ? "onboarding.titles.imports" : "onboarding.progress.review",
  ] as const;
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center mb-6">
      {steps.map((label, i) => {
        const idx = i + 1;
        const isActive = step === idx;
        const isDone = step > idx;

        const bubbleCls = [
          "w-8 h-8 rounded-full inline-flex items-center justify-center",
          "text-[13px] font-medium leading-none",
          A.num, // ✅ tabular numbers
          isActive
            ? "bg-appleblue text-white"
            : isDone
            ? "bg-appleblue/10 text-appleblue ring-1 ring-appleblue/20"
            : "bg-gray-100 text-gray-400",
        ].join(" ");

        const barCls = [
          "w-4 h-1 mx-1 sm:w-10 sm:mx-2 rounded-full",
          isDone ? "bg-appleblue" : "bg-gray-100",
        ].join(" ");

        return (
          <div key={i} className="flex items-center">
            <div className={bubbleCls} aria-label={t(label)} title={t(label)} aria-current={isActive ? "step" : undefined}>
              {idx}
            </div>

            {i !== steps.length - 1 && <div className={barCls} aria-hidden="true" />}
          </div>
        );
      })}
    </div>
  );
}
